import { render, staticRenderFns } from "./ContactItem.vue?vue&type=template&id=c3f2136a"
import script from "./ContactItem.vue?vue&type=script&lang=ts"
export * from "./ContactItem.vue?vue&type=script&lang=ts"
import style0 from "./ContactItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default})
